module.exports = window.d3;